module.exports = __webpack_public_path__ + "static/img/calm2_tr.01d4fcd9.png";